// extracted by mini-css-extract-plugin
export default {"main":"AIData_main__6+8rp","text":"AIData_text__ZtDyQ","icon":"AIData_icon__Sonpg"};